export const HIRED_STAGE = 'hired_stage';
